import gqlTagGira from 'graphql-tag';

export const RADIO_SELECT_FRAGMENT = gqlTagGira`
    fragment jiraRadioSelectFieldFragment on JiraRadioSelectField {
        id
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedOption {
            optionId
            value
        }
    }
`;
